import os from 'os'

let apiProtocol = 'https://'
let sslProtocol = 'https://'

//Use during SSL
const productionAPIHost = 'api.healthsetgo.com'
const productionURLs = ['healthsetgo.com', productionAPIHost]
const productionAPIPort = ''

//const productionAPIHost = '13.126.89.179'
//const productionURLs = ['localhost', productionAPIHost]
//const productionAPIPort = ''

//const stagingAPIHost = '35.154.246.223'
//const stagingURLs = ['localhost', stagingAPIHost]
//const stagingAPIPort = ''


//----------- PRODUCTION SECTION ----------------//
const apiHost = productionAPIHost
const devPort = ''
const apiPort = productionAPIPort
const apiUrl = sslProtocol + apiHost
const s3URL = "http://hsgbucket.s3.amazonaws.com"

//----------- STAGING SECTION ----------------//
//const apiHost = stagingAPIHost
//const devPort = ''
//const apiPort = stagingAPIPort
//const apiUrl = apiProtocol + apiHost
//const s3URL = "http://hsgbucket.s3.amazonaws.com"

const qcCheckedStatusMap = {
  CHECKED: 45,
  PUBLISHED: 46
}

const activeStatusMap = {
  ACTIVE: 1,
  DRAFT: 2,
  DELETE: 3
}

const orgTypeMap = {
  SCHOOL: 1,
  MSP: 2,
  ISP: 3
}

const allTabsMap = {
  SCHOOL: 'school',
  QC: 'qc',
  QC_DETAIL: 'qc-detail',
  TC: 'tc',
  MANAGER: 'manager'
}

//---------- CONSTANTS USED FOR CLIENT -----------//

const roles = {
  1: { value: 'HSG OPS', orgActive: 
    {
      [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE}}`
    }
  },
  2: { value: 'HSG Finance' },
  //3: { value: 'HSG Community Manager' },
  4: { value: 'School Admin' },
  5: { value: 'Parent' },
  6: { value: 'Finance team' },
  7: { value: 'In-house doctor/CHM' },
  3: { value: 'CHM', detail: 'Community Health Manager', orgActive: 
    {
      [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE}}`
    } 
  },
  8: { value: 'CHM Manager', orgActive: 
    {
        [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE}}`
    } 
  },
  9: { value: 'Student' },
  //10: { value: 'Guest' },
  14: { value: 'HSG SA ISP', orgActive: 
    {
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`      
    }
  },
  15: { value: 'HSG SA MSP', orgActive: 
    {
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,      
    }
  },
  17: { value: 'HSG Ops Manager', orgActive: 
    {
      [orgTypeMap.SCHOOL] : `{${activeStatusMap.ACTIVE},${activeStatusMap.DRAFT}}`,
      [orgTypeMap.MSP] : `{${activeStatusMap.ACTIVE}}`,
      [orgTypeMap.ISP] : `{${activeStatusMap.ACTIVE}}`
    }
  }
}

/* 
1 | OPS
2 | Finance
3 | CHM
4 | School Admin
5 | Parent
6 | Finance team
7 | In-house doctor/CHM
8 | CHM Manager
9 | Student
10 | Doctor
11 | Onsite Coordinator
12 | HSG Super Admin
13 | Guest
14 | SA-ISP
15 | SA-MSP
16 | CEO(Super Admin)
17 | OPS Manager


const roles = {
  'OPS_MANAGER' : {value: 'HSG Ops Manager'},
  2 : {value: 'HSG Finance'},
  3 : {value: 'HSG Community Manager'},
  4 : {value: 'School Admin'},
  5 : {value: 'Parent'},
  6 : {value: 'Finance team'},
  7 : {value: 'In-house doctor/CHM'},
  'CHM' : {value: 'CHM', detail: 'Community Health Manager'},
  9 : {value: 'Student'},
 10 : {value: 'Guest'},
} */

const getIdFromUrl = (url, pos) => {
  url = url.split('/')
  return parseInt(url[url.length - pos], 10)
}

const roleIdMap = {
  'OPS_MANAGER': 17,
  'CHM': 3,
  'CHM_MANAGER': 8,
  'SCHOOL_ADMIN': 4
}

const programIdMap = {
  'Care': 2,
  'Old Care': 692
}

/**
 * Please find the roles and its id's below
 */

/* 1 | OPS
2 | Finance
3 | CHM
4 | School Admin
5 | Parent
6 | Finance team
7 | In - house doctor / CHM
8 | CHM Manager
9 | Student
10 | Doctor
11 | Onsite Coordinator
12 | HSG Super Admin
13 | Guest
14 | SA - ISP
15 | SA - MSP
16 | CEO(Super Admin)
17 | OPS Manager */

const roleIdMapV2 = {
  'OPS_MANAGER': { value: 17, detail: 'HSG Ops Manager', orgActive: '{1,2}' },
  'CHM': { value: 3, detail: 'Community Health Manager', orgActive: '{1}' },
  'CHM_MANAGER': { value: 8, detail: 'CHM Manager', orgActive: '{1}'},
  'SCHOOL_ADMIN': { value: 4, detail: 'SCHOOL_ADMIN', orgActive: '{1}'},
  'GUEST_USER': { value: 13, detail: 'GUEST_USER', orgActive: '{1}'}
}

// 31 | Created
// 32 | Scheduled
// 33 | In Progress
// 34 | Complete
// 35 | Cancelled

const eventTrackStatus = {
  CREATED: 31,
  SCHEDULED: 32,
  IN_PROGRESS: 33,
  COMPLETE: 34,
  CANCELLED: 35
}

const eventTrackRankMap = {
  START_NODE: 1,
  ONBOARD_SCHOOL: 2,
  CAREBOX: 3,
  VISION_CAREBOX: 3,
  BALANCED_CAREBOX: 3,
  SUGAR_CAREBOX: 3,
  BLOOD_DONATION_CAREBOX: 3,
  IMMUNIZATION_CAREBOX: 3,
  HEART_CAREBOX: 3,
  HYGIENE_CAREBOX: 3,
  STUDENT_LIST: 4,
  SCHEDULE_HEATH_CHECKUP: 5,
  DOWNLOAD_OMR: 6,
  HEALTH_CHECKUP: 7,
  UPLOAD_HEATH_CHECKUP_DATA: 8,
  QC: 9,
  TC: 10,
  END_NODE: 11
}

const getNode = (events, filterVal) => {
  let startNode = [];
  if (events && events.length > 0) {
    startNode = events.filter((e, i) => {
      if (Boolean(e.event_custom_json)) {
        return e.event_custom_json.name === filterVal
      }
    })
    return startNode.length > 0 ? startNode[0] : undefined
  } else return []
}


// nodeId of the Student Assessment Data Node to be excluded from View/Edit
const qcMetricsInertNodeId = 1;

const defaultRegionCodes = {
  INDIA_COUNTRY_CODE: 3
}

const userPermissionId = {
  EDIT: 1
}
const userPermissionMap = {
  [roleIdMapV2.SCHOOL_ADMIN.value]: [
    userPermissionId.EDIT
  ],
  [roleIdMapV2.GUEST_USER.value]: []
}

export default {
  userPermissionMap,
  userPermissionId,
  programIdMap,
  getNode,
  getIdFromUrl,
  roles,
  roleIdMap,
  roleIdMapV2,
  apiUrl,
  apiHost,
  apiProtocol,
  sslProtocol,
  devPort,
  apiPort,
  s3URL,
  activeStatusMap,
  orgTypeMap,
  eventTrackStatus,
  qcCheckedStatusMap,
  qcMetricsInertNodeId,
  eventTrackRankMap,
  allTabsMap,
  defaultRegionCodes
}



// WEBPACK FOOTER //
// ./src/Phi/Constants.js